import { NgModule } from '@angular/core';

import { TixxSelectTranslationsService } from './alerts/tixx-select-overview-translations.service';
import { ClubStatusTranslationsService } from './club/club-status-translations.service';
import { ActivityHistoryTranslationsService } from './customer/activity-history-translations.service';
import { ReminderStatusTranslationsService } from './customer/reminder-status-translations.service';
import { TixxSelectSubmissionStatusTranslationsService } from './customer/tixx-select-submission-status-translations.service';
import { LotteryStatusTranslationService } from './lottery-status-translations.service';
import { CustomerScoreTranslationsService } from './customer/customer-score-translations.service';
import { DeliveryMethodTranslationService } from './delivery-methods-translations.service';
import { TixxFanPortalTranslationsService } from './alerts/tixx-fan-portal-translations.service';
import {
  ClubListTranslationsService,
  ClubTranslationsService,
  ContactManagementTranslationsService,
  CreateCustomerTranslationsService,
  CustomerAddressTranslationsService,
  CustomerOverviewTranslationsService,
  CustomerStatusTranslationsService,
  ImportCustomerTranslationsService,
  LoginTranslationsService,
  SharedTranslationsService,
} from './index';

/**
 * App module bootstrap file.
 */
@NgModule({
  imports: [],
  declarations: [],
  providers: [
    ActivityHistoryTranslationsService,
    ClubListTranslationsService,
    ClubTranslationsService,
    ContactManagementTranslationsService,
    CreateCustomerTranslationsService,
    CustomerOverviewTranslationsService,
    CustomerAddressTranslationsService,
    CustomerStatusTranslationsService,
    ImportCustomerTranslationsService,
    LoginTranslationsService,
    SharedTranslationsService,
    ClubStatusTranslationsService,
    ReminderStatusTranslationsService,
    TixxSelectTranslationsService,
    LotteryStatusTranslationService,
    TixxSelectSubmissionStatusTranslationsService,
    CustomerScoreTranslationsService,
    DeliveryMethodTranslationService,
    TixxFanPortalTranslationsService
  ]
})
export class TranslationsModule { }
